export const getDisplayValue = (data: Array<string | number | undefined>) => {
  const fields = data.filter(Boolean);
  return fields.length ? fields.join(", ") : "-";
};
